import { jsxs, jsx } from "react/jsx-runtime";
const IconCoverLetterSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    fill: "currentColor",
    width: 16,
    height: 16,
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M13 10H7a1 1 0 1 1 0-2h6a1 1 0 1 1 0 2Zm0 4H7a1 1 0 1 1 0-2h6a1 1 0 1 1 0 2Z" }),
      /* @__PURE__ */ jsx("rect", { x: 4, y: 4, width: 12, height: 16, rx: 1, ry: 1, fill: "none" }),
      /* @__PURE__ */ jsx("rect", { x: 4, y: 4, width: 12, height: 16, rx: 1, ry: 1, fill: "none" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M19 4h-1.184c.112.314.184.648.184 1v14c0 .352-.072.686-.184 1H19a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1Z",
          fill: "none"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M19 2H7.871c-.275-.578-.694-.955-1.17-.955s-.897.377-1.172.955H5C3.346 2 2 3.346 2 5v14c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3V5c0-1.654-1.346-3-3-3Zm-3 17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h.228c.128 1.163.737 2.045 1.472 2.045S8.044 5.163 8.173 4H15a1 1 0 0 1 1 1v14Zm4 0a1 1 0 0 1-1 1h-1.184c.112-.314.184-.648.184-1V5c0-.352-.072-.686-.184-1H19a1 1 0 0 1 1 1v14Z" })
    ]
  }
);
export {
  IconCoverLetterSvg
};
